(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-i18n-phrase-in-context-editor"] = factory();
	else
		root["vue-i18n-phrase-in-context-editor"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 